var map = {
	"./de/bg.jpg": "NMB3",
	"./en/bg.jpg": "uPaV",
	"./es/bg.jpg": "wZAC",
	"./fr/bg.jpg": "PXs3",
	"./ja/bg.jpg": "1Eve",
	"./ko/bg.jpg": "OPWP",
	"./pt/bg.jpg": "wi3K",
	"./ru/bg.jpg": "rix1",
	"./tc/bg.jpg": "UJmL",
	"./th/bg.jpg": "8ofN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0GSX";